import { useState } from 'react';
import { Meta } from '@/components/common';
import { Container } from '@/components/layout';
import { ReleaseTable } from '@/components/features/release-management';
import { VersionAdoption, VersionTable } from '@/components/features/releases';
import { Tabs, TabsList, TabsTrigger } from '@/shared/ui/tabs';

type Tab = 'releases' | 'builds';

/**
 * Releases and the builds inside them.
 *
 * Releases is where the ops team decides what goes out: CI registers each
 * build into a draft release, and nothing reaches a desktop until it is
 * released here. Builds is the raw list of installers CI registered, with
 * what versions machines are actually running.
 */
export function ReleasesPage({ initialTab = 'releases' }: { initialTab?: Tab }) {
  const [tab, setTab] = useState<Tab>(initialTab);

  return (
    <>
      <Meta title="Releases" />

      <Container className="space-y-6">
        <div className="flex flex-wrap items-center justify-between gap-3">
          <Tabs
            value={tab}
            onValueChange={(value) => {
              setTab(value as Tab);
            }}
          >
            <TabsList>
              <TabsTrigger value="releases">Releases</TabsTrigger>
              <TabsTrigger value="builds">Builds</TabsTrigger>
            </TabsList>
          </Tabs>
          <p className="text-[12.5px] text-muted-foreground">
            {tab === 'releases'
              ? 'Desktops are offered a version only once it is released here.'
              : 'Installers CI registered. Each belongs to the release for its version.'}
          </p>
        </div>

        {tab === 'releases' ? (
          <ReleaseTable />
        ) : (
          <>
            <VersionTable />
            <VersionAdoption />
          </>
        )}
      </Container>
    </>
  );
}
